import React from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Primary and secondary actions for this view. */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Every section previously opened with a centred block: a 4xl display title,
 * a coloured subtitle, and a third grey line — roughly 180px of the viewport
 * spent restating the tab the reader had just clicked, pushing the actual
 * numbers below the fold. Attention is strongest top-left and falls away to
 * the right and down, so that band belongs to the metrics, not to a caption.
 *
 * This is the compact, left-aligned replacement: one line of identity, one
 * line of purpose, and the actions for the view on the same row.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, className = '' }) => (
  <div className={`flex flex-wrap items-start justify-between gap-x-6 gap-y-3 ${className}`}>
    <div className="min-w-0">
      <h1 className="text-xl font-bold leading-7 tracking-tight text-ink">{title}</h1>
      {description ? <p className="mt-1 text-sm leading-6 text-ink-2">{description}</p> : null}
    </div>
    {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);

export default PageHeader;
